import { PaymentData } from '@/state/payment'
import { PaymentMethodInputTypes } from '@/utils/constants'
import { formatPaymentUserName } from '@/utils/helpers'
import { formatMagensaExpiration, getNetworkFromBin } from '@/utils/magensa'

export interface MagensaDoneData {
  token: string
  cardLast4: string
  cardFirst6?: string
  cardExpiration: string
}

export interface MagensaUser {
  first_name?: string
  last_name?: string
}

/**
 * Constructs a PaymentData object from a Magensa Unigate magensaDone event payload.
 */
export function buildMagensaPaymentMethod(data: MagensaDoneData, user: MagensaUser | null | undefined): PaymentData {
  const { token, cardLast4, cardFirst6, cardExpiration } = data
  const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim()

  return {
    network: getNetworkFromBin(cardFirst6 || ''),
    name: formatPaymentUserName(fullName),
    pan_mask: `************${cardLast4}`,
    input_mode: PaymentMethodInputTypes.MAGENSA_UNIGATE_ECOMMERCE_MANUAL_KEYED,
    card_token: token,
    expiration: formatMagensaExpiration(cardExpiration),
  }
}
